export const SUPPORTED_PANCHANG_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "Hindi" },
  { code: "ta", label: "Tamil" },
  { code: "te", label: "Telugu" },
  { code: "kn", label: "Kannada" },
  { code: "ml", label: "Malayalam" },
];

export const PANCHANG_COPY = {
  en: {
    languageLabel: "Language",
    locale: "en-IN",
    landingEyebrow: "Panchang",
    landingTitle: "Trusted Panchang, beautifully built.",
    landingBody:
      "A location-aware Vedic calendar suite for today's Panchang, tomorrow's Panchang, festivals, vrat dates, Hindu calendars, and timing utilities.",
    ctaToday: "See Today's Panchang",
    ctaTomorrow: "See Tomorrow's Panchang",
    ctaCalendar: "Open Calendar",
    dailyEyebrow: "Daily Panchang",
    dailyLoading: "Opening today's day intelligence",
    dailyBody: "Location-first daily Vedic timing with clear day-quality windows and observance context.",
    festivalEyebrow: "Festivals And Vrat",
    festivalTitle: "Upcoming observances in the current year",
    festivalBody: "Use this as a discovery hub, then drill into the exact date page for day-level Panchang context.",
    navToday: "Today",
    navTomorrow: "Tomorrow",
    navFestivals: "Festivals",
    navCalendar: "Calendar",
    openDate: "Open Date",
    dailyLabels: {
      date: "Date",
      country: "Country",
      locationTimezone: "Location / Timezone",
      openPanchang: "Open Panchang",
      sunrise: "Sunrise",
      sunset: "Sunset",
      moonrise: "Moonrise",
      moonset: "Moonset",
      tithi: "Tithi",
      nakshatra: "Nakshatra",
      yoga: "Yoga",
      karana: "Karana",
      paksha: "Paksha",
      lunarMonth: "Lunar Month",
      moonSign: "Moon Sign",
      sunSign: "Sun Sign",
      samvat: "Samvat",
      corePanchang: "Core Panchang",
      segmentTimings: "Segment Timings",
      tithiEnds: "Tithi ends",
      nakshatraEnds: "Nakshatra ends",
      yogaEnds: "Yoga ends",
      karanaEnds: "Karana ends",
      dayQuality: "Day Quality",
      specialTimings: "Special Nakshatra Windows",
      varjyam: "Varjyam",
      amritKalam: "Amrit Kalam",
      lagnaKundali: "Lagna Kundali",
      ascendant: "Ascendant",
      degree: "Degree",
      house: "House",
      observances: "Observances",
      keepExploring: "Keep Exploring",
      notAvailable: "Not available",
      unavailable: "Unavailable",
      noMarker: "No major festival or vrat marker is attached to this date in the current bootstrap rule set.",
      asc: "Asc",
    },
    calendarLabels: {
      eyebrow: "Hindu Calendar",
      loading: "Loading calendar...",
      openingMonthView: "Opening month view",
      body: "Browse a month of date pages, tithi markers, and observance-heavy days.",
      tamilPanchangam: "Tamil Panchangam",
      teluguPanchangam: "Telugu Panchangam",
      noMajorMarker: "No major marker",
    },
  },
  hi: {
    languageLabel: "भाषा",
    locale: "hi-IN",
    landingEyebrow: "पंचांग",
    landingTitle: "विश्वसनीय पंचांग, सुंदर रूप में.",
    landingBody:
      "आज का पंचांग, कल का पंचांग, व्रत, त्योहार, हिंदू कैलेंडर और समय-आधारित उपयोगिताओं के लिए स्थान-आधारित वैदिक कैलेंडर.",
    ctaToday: "आज का पंचांग",
    ctaTomorrow: "कल का पंचांग",
    ctaCalendar: "कैलेंडर खोलें",
    dailyEyebrow: "दैनिक पंचांग",
    dailyLoading: "आज की पंचांग जानकारी खुल रही है",
    dailyBody: "स्थान-आधारित वैदिक समय, स्पष्ट दैनिक कालखंडों और पर्व संदर्भ के साथ.",
    festivalEyebrow: "त्योहार और व्रत",
    festivalTitle: "इस वर्ष के प्रमुख पर्व और व्रत",
    festivalBody: "यहां से तिथि-आधारित पंचांग विवरण तक जाएं.",
    navToday: "आज",
    navTomorrow: "कल",
    navFestivals: "त्योहार",
    navCalendar: "कैलेंडर",
    openDate: "तिथि खोलें",
    dailyLabels: {
      date: "तिथि",
      country: "देश",
      locationTimezone: "स्थान / समय क्षेत्र",
      openPanchang: "पंचांग खोलें",
      sunrise: "सूर्योदय",
      sunset: "सूर्यास्त",
      moonrise: "चंद्रोदय",
      moonset: "चंद्रास्त",
      tithi: "तिथि",
      nakshatra: "नक्षत्र",
      yoga: "योग",
      karana: "करण",
      paksha: "पक्ष",
      lunarMonth: "चंद्र मास",
      moonSign: "चंद्र राशि",
      sunSign: "सूर्य राशि",
      samvat: "संवत",
      corePanchang: "मुख्य पंचांग",
      segmentTimings: "समाप्ति समय",
      tithiEnds: "तिथि समाप्ति",
      nakshatraEnds: "नक्षत्र समाप्ति",
      yogaEnds: "योग समाप्ति",
      karanaEnds: "करण समाप्ति",
      dayQuality: "दैनिक कालखंड",
      specialTimings: "विशेष नक्षत्र काल",
      varjyam: "वर्ज्यम",
      amritKalam: "अमृत काल",
      lagnaKundali: "लग्न कुंडली",
      ascendant: "लग्न",
      degree: "अंश",
      house: "भाव",
      observances: "पर्व और व्रत",
      keepExploring: "और देखें",
      notAvailable: "उपलब्ध नहीं",
      unavailable: "अनुपलब्ध",
      noMarker: "इस तिथि पर वर्तमान नियम-आधारित सेट में कोई प्रमुख पर्व या व्रत संकेतक नहीं है।",
      asc: "लग्न",
    },
    calendarLabels: {
      eyebrow: "हिंदू कैलेंडर",
      loading: "कैलेंडर लोड हो रहा है...",
      openingMonthView: "मासिक दृश्य खुल रहा है",
      body: "महीने भर की तिथियां, तिथि संकेत और प्रमुख पर्व देखें।",
      tamilPanchangam: "तमिल पंचांगम",
      teluguPanchangam: "तेलुगु पंचांगम",
      noMajorMarker: "कोई प्रमुख संकेत नहीं",
    },
  },
  ta: {
    languageLabel: "மொழி",
    locale: "ta-IN",
    landingEyebrow: "பஞ்சாங்கம்",
    landingTitle: "நம்பகமான பஞ்சாங்கம், அழகாக வடிவமைக்கப்பட்டது.",
    landingBody:
      "இன்றைய பஞ்சாங்கம், நாளைய பஞ்சாங்கம், விரதங்கள், திருநாள்கள், இந்து காலண்டர் மற்றும் கால அடிப்படையிலான பயன்பாடுகளுக்கான இடவசதி கொண்ட வேத காலண்டர்.",
    ctaToday: "இன்றைய பஞ்சாங்கம்",
    ctaTomorrow: "நாளைய பஞ்சாங்கம்",
    ctaCalendar: "காலண்டரை திறக்கவும்",
    dailyEyebrow: "தினசரி பஞ்சாங்கம்",
    dailyLoading: "இன்றைய பஞ்சாங்க தகவல் திறக்கப்படுகிறது",
    dailyBody: "இடவசதி சார்ந்த வேத கால அளவுகள் மற்றும் தெளிவான தினசரி காலखंडங்கள்.",
    festivalEyebrow: "திருநாள்கள் மற்றும் விரதங்கள்",
    festivalTitle: "இந்த ஆண்டின் முக்கிய வழிபாட்டு நாட்கள்",
    festivalBody: "இங்கிருந்து குறிப்பிட்ட தேதியின் பஞ்சாங்க விவரத்திற்குச் செல்லலாம்.",
    navToday: "இன்று",
    navTomorrow: "நாளை",
    navFestivals: "திருநாள்கள்",
    navCalendar: "காலண்டர்",
    openDate: "தேதியைத் திறக்கவும்",
    dailyLabels: {
      date: "தேதி",
      country: "நாடு",
      locationTimezone: "இடம் / நேர மண்டலம்",
      openPanchang: "பஞ்சாங்கம் திறக்கவும்",
      sunrise: "சூரியோதயம்",
      sunset: "சூரியாஸ்தமனம்",
      moonrise: "சந்திரோதயம்",
      moonset: "சந்திராஸ்தமனம்",
      tithi: "திதி",
      nakshatra: "நட்சத்திரம்",
      yoga: "யோகம்",
      karana: "கரணம்",
      paksha: "பட்சம்",
      lunarMonth: "சந்திர மாதம்",
      moonSign: "சந்திர ராசி",
      sunSign: "சூரிய ராசி",
      samvat: "சம்வத்",
      corePanchang: "முக்கிய பஞ்சாங்கம்",
      segmentTimings: "கால முடிவு விவரங்கள்",
      tithiEnds: "திதி முடிவு",
      nakshatraEnds: "நட்சத்திர முடிவு",
      yogaEnds: "யோகம் முடிவு",
      karanaEnds: "கரணம் முடிவு",
      dayQuality: "நாள் தர நேரங்கள்",
      specialTimings: "சிறப்பு நட்சத்திர காலங்கள்",
      varjyam: "வர்ஜியம்",
      amritKalam: "அமிர்த காலம்",
      lagnaKundali: "லக்ன குண்டலி",
      ascendant: "லக்னம்",
      degree: "அளவு",
      house: "பாவம்",
      observances: "விரதங்கள் மற்றும் திருநாள்கள்",
      keepExploring: "மேலும் பாருங்கள்",
      notAvailable: "கிடைக்கவில்லை",
      unavailable: "தகவல் இல்லை",
      noMarker: "தற்போதைய விதிமுறை அடிப்படையிலான அமைப்பில் இந்த தேதிக்கு பெரிய திருநாள் அல்லது விரத குறிப்பு இல்லை.",
      asc: "லக்னம்",
    },
    calendarLabels: {
      eyebrow: "இந்துக் காலண்டர்",
      loading: "காலண்டர் திறக்கப்படுகிறது...",
      openingMonthView: "மாதக் காட்சி திறக்கப்படுகிறது",
      body: "மாதம் முழுவதும் தேதிகள், திதி குறிப்புகள் மற்றும் முக்கிய திருநாள் நாட்களை பாருங்கள்.",
      tamilPanchangam: "தமிழ் பஞ்சாங்கம்",
      teluguPanchangam: "தெலுங்கு பஞ்சாங்கம்",
      noMajorMarker: "முக்கிய குறிப்பு இல்லை",
    },
  },
  te: {
    languageLabel: "భాష",
    locale: "te-IN",
    landingEyebrow: "పంచాంగం",
    landingTitle: "నమ్మదగిన పంచాంగం, అందంగా రూపకల్పన చేయబడింది.",
    landingBody:
      "ఈరోజు పంచాంగం, రేపటి పంచాంగం, వ్రతాలు, పండుగలు, హిందూ క్యాలెండర్ మరియు సమయ ఆధారిత ఉపయోగాల కోసం స్థలాధారిత వేదిక క్యాలెండర్.",
    ctaToday: "ఈరోజు పంచాంగం",
    ctaTomorrow: "రేపటి పంచాంగం",
    ctaCalendar: "క్యాలెండర్ తెరవండి",
    dailyEyebrow: "దైనందిన పంచాంగం",
    dailyLoading: "ఈరోజు పంచాంగ సమాచారం తెరుచుకుంటోంది",
    dailyBody: "స్థానాధారిత వైదిక కాల వివరాలు మరియు స్పష్టమైన దినచర్య సమయాలు.",
    festivalEyebrow: "పండుగలు మరియు వ్రతాలు",
    festivalTitle: "ఈ సంవత్సరంలోని ముఖ్య ఆచరణ దినాలు",
    festivalBody: "ఇక్కడి నుండి నిర్దిష్ట తేదీ పంచాంగ వివరాలకు వెళ్లండి.",
    navToday: "ఈరోజు",
    navTomorrow: "రేపు",
    navFestivals: "పండుగలు",
    navCalendar: "క్యాలెండర్",
    openDate: "తేదీ తెరవండి",
    dailyLabels: {
      date: "తేదీ",
      country: "దేశం",
      locationTimezone: "స్థానం / టైమ్‌జోన్",
      openPanchang: "పంచాంగం తెరవండి",
      sunrise: "సూర్యోదయం",
      sunset: "సూర్యాస్తమయం",
      moonrise: "చంద్రోదయం",
      moonset: "చంద్రాస్తమయం",
      tithi: "తిథి",
      nakshatra: "నక్షత్రం",
      yoga: "యోగం",
      karana: "కరణం",
      paksha: "పక్షం",
      lunarMonth: "చాంద్రమాసం",
      moonSign: "చంద్ర రాశి",
      sunSign: "సూర్య రాశి",
      samvat: "సంవత్",
      corePanchang: "ముఖ్య పంచాంగం",
      segmentTimings: "ముగింపు సమయాలు",
      tithiEnds: "తిథి ముగింపు",
      nakshatraEnds: "నక్షత్ర ముగింపు",
      yogaEnds: "యోగ ముగింపు",
      karanaEnds: "కరణ ముగింపు",
      dayQuality: "దిన గుణ సమయాలు",
      specialTimings: "ప్రత్యేక నక్షత్ర సమయాలు",
      varjyam: "వర్జ్యం",
      amritKalam: "అమృత కాలం",
      lagnaKundali: "లగ్న కుండలి",
      ascendant: "లగ్నం",
      degree: "డిగ్రీ",
      house: "భావం",
      observances: "ఆచరణలు మరియు వ్రతాలు",
      keepExploring: "ఇంకా చూడండి",
      notAvailable: "అందుబాటులో లేదు",
      unavailable: "లభ్యం కాదు",
      noMarker: "ప్రస్తుత నియమ ఆధారిత వ్యవస్థలో ఈ తేదీకి ప్రధాన పండుగ లేదా వ్రత సూచిక లేదు.",
      asc: "లగ్నం",
    },
    calendarLabels: {
      eyebrow: "హిందూ క్యాలెండర్",
      loading: "క్యాలెండర్ లోడ్ అవుతోంది...",
      openingMonthView: "నెల దృశ్యం తెరుచుకుంటోంది",
      body: "ఒక నెల తేదీలు, తిథి సూచికలు, మరియు ముఖ్య ఆచరణ దినాలను చూడండి.",
      tamilPanchangam: "తమిళ పంచాంగం",
      teluguPanchangam: "తెలుగు పంచాంగం",
      noMajorMarker: "ప్రధాన సూచిక లేదు",
    },
  },
  kn: {
    languageLabel: "ಭಾಷೆ",
    locale: "kn-IN",
    landingEyebrow: "ಪಂಚಾಂಗ",
    landingTitle: "ನಂಬಲರ್ಹ ಪಂಚಾಂಗ, ಸುಂದರವಾಗಿ ರೂಪಿಸಲಾಗಿದೆ.",
    landingBody:
      "ಇಂದಿನ ಪಂಚಾಂಗ, ನಾಳೆಯ ಪಂಚಾಂಗ, ವ್ರತಗಳು, ಹಬ್ಬಗಳು, ಹಿಂದೂ ಕ್ಯಾಲೆಂಡರ್ ಮತ್ತು ಕಾಲಾಧಾರಿತ ಉಪಯೋಗಗಳಿಗಾಗಿ ಸ್ಥಳಾಧಾರಿತ ವೇದಿಕ ಕ್ಯಾಲೆಂಡರ್.",
    ctaToday: "ಇಂದಿನ ಪಂಚಾಂಗ",
    ctaTomorrow: "ನಾಳೆಯ ಪಂಚಾಂಗ",
    ctaCalendar: "ಕ್ಯಾಲೆಂಡರ್ ತೆರೆಯಿರಿ",
    dailyEyebrow: "ದೈನಂದಿನ ಪಂಚಾಂಗ",
    dailyLoading: "ಇಂದಿನ ಪಂಚಾಂಗ ಮಾಹಿತಿ ತೆರೆಯುತ್ತಿದೆ",
    dailyBody: "ಸ್ಥಳಾಧಾರಿತ ವೈದಿಕ ಕಾಲಮಾಪನ ಮತ್ತು ಸ್ಪಷ್ಟ ದಿನದ ಕಾಲಖಂಡಗಳು.",
    festivalEyebrow: "ಹಬ್ಬಗಳು ಮತ್ತು ವ್ರತಗಳು",
    festivalTitle: "ಈ ವರ್ಷದ ಮುಖ್ಯ ಆಚರಣೆ ದಿನಗಳು",
    festivalBody: "ಇಲ್ಲಿಂದ ನಿರ್ದಿಷ್ಟ ದಿನದ ಪಂಚಾಂಗ ವಿವರಗಳಿಗೆ ಹೋಗಿ.",
    navToday: "ಇಂದು",
    navTomorrow: "ನಾಳೆ",
    navFestivals: "ಹಬ್ಬಗಳು",
    navCalendar: "ಕ್ಯಾಲೆಂಡರ್",
    openDate: "ದಿನಾಂಕ ತೆರೆಯಿರಿ",
    dailyLabels: {
      date: "ದಿನಾಂಕ",
      country: "ದೇಶ",
      locationTimezone: "ಸ್ಥಳ / ಸಮಯ ವಲಯ",
      openPanchang: "ಪಂಚಾಂಗ ತೆರೆಯಿರಿ",
      sunrise: "ಸೂರ್ಯೋದಯ",
      sunset: "ಸೂರ್ಯಾಸ್ತ",
      moonrise: "ಚಂದ್ರೋದಯ",
      moonset: "ಚಂದ್ರಾಸ್ತ",
      tithi: "ತಿಥಿ",
      nakshatra: "ನಕ್ಷತ್ರ",
      yoga: "ಯೋಗ",
      karana: "ಕರಣ",
      paksha: "ಪಕ್ಷ",
      lunarMonth: "ಚಾಂದ್ರ ಮಾಸ",
      moonSign: "ಚಂದ್ರ ರಾಶಿ",
      sunSign: "ಸೂರ್ಯ ರಾಶಿ",
      samvat: "ಸಂವತ್ಸರ",
      corePanchang: "ಮುಖ್ಯ ಪಂಚಾಂಗ",
      segmentTimings: "ಅಂತ್ಯ ಸಮಯಗಳು",
      tithiEnds: "ತಿಥಿ ಅಂತ್ಯ",
      nakshatraEnds: "ನಕ್ಷತ್ರ ಅಂತ್ಯ",
      yogaEnds: "ಯೋಗ ಅಂತ್ಯ",
      karanaEnds: "ಕರಣ ಅಂತ್ಯ",
      dayQuality: "ದಿನ ಗುಣ ಕಾಲಗಳು",
      specialTimings: "ವಿಶೇಷ ನಕ್ಷತ್ರ ಕಾಲಗಳು",
      varjyam: "ವರ್ಜ್ಯಂ",
      amritKalam: "ಅಮೃತ ಕಾಲ",
      lagnaKundali: "ಲಗ್ನ ಕುಂಡಲಿ",
      ascendant: "ಲಗ್ನ",
      degree: "ಅಂಶ",
      house: "ಭಾವ",
      observances: "ಆಚರಣೆಗಳು ಮತ್ತು ವ್ರತಗಳು",
      keepExploring: "ಮುಂದೆ ನೋಡಿ",
      notAvailable: "ಲಭ್ಯವಿಲ್ಲ",
      unavailable: "ಮಾಹಿತಿ ಇಲ್ಲ",
      noMarker: "ಪ್ರಸ್ತುತ ನಿಯಮಾಧಾರಿತ ವ್ಯವಸ್ಥೆಯಲ್ಲಿ ಈ ದಿನಕ್ಕೆ ಪ್ರಮುಖ ಹಬ್ಬ ಅಥವಾ ವ್ರತ ಸೂಚನೆ ಇಲ್ಲ.",
      asc: "ಲಗ್ನ",
    },
    calendarLabels: {
      eyebrow: "ಹಿಂದೂ ಕ್ಯಾಲೆಂಡರ್",
      loading: "ಕ್ಯಾಲೆಂಡರ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
      openingMonthView: "ತಿಂಗಳ ದೃಶ್ಯ ತೆರೆಯುತ್ತಿದೆ",
      body: "ಒಂದು ತಿಂಗಳ ದಿನಾಂಕಗಳು, ತಿಥಿ ಗುರುತುಗಳು ಮತ್ತು ಪ್ರಮುಖ ಆಚರಣೆ ದಿನಗಳನ್ನು ನೋಡಿ.",
      tamilPanchangam: "ತಮಿಳು ಪಂಚಾಂಗ",
      teluguPanchangam: "ತೆಲುಗು ಪಂಚಾಂಗ",
      noMajorMarker: "ಪ್ರಮುಖ ಸೂಚನೆ ಇಲ್ಲ",
    },
  },
  ml: {
    languageLabel: "ഭാഷ",
    locale: "ml-IN",
    landingEyebrow: "പഞ്ചാംഗം",
    landingTitle: "വിശ്വസനീയമായ പഞ്ചാംഗം, മനോഹരമായി രൂപകൽപ്പന ചെയ്തത്.",
    landingBody:
      "ഇന്നത്തെ പഞ്ചാംഗം, നാളത്തെ പഞ്ചാംഗം, വ്രതങ്ങൾ, ഉത്സവങ്ങൾ, ഹിന്ദു കലണ്ടർ, സമയാടിസ്ഥാനത്തിലുള്ള ഉപയോഗങ്ങൾക്കായി സ്ഥാനബോധമുള്ള വേദിക കലണ്ടർ.",
    ctaToday: "ഇന്നത്തെ പഞ്ചാംഗം",
    ctaTomorrow: "നാളത്തെ പഞ്ചാംഗം",
    ctaCalendar: "കലണ്ടർ തുറക്കുക",
    dailyEyebrow: "ദിനസരി പഞ്ചാംഗം",
    dailyLoading: "ഇന്നത്തെ പഞ്ചാംഗ വിവരം തുറക്കുന്നു",
    dailyBody: "സ്ഥാനാടിസ്ഥാനത്തിലുള്ള വേദിക സമയവിവരങ്ങളും വ്യക്തമായ ദിനഘട്ടങ്ങളും.",
    festivalEyebrow: "ഉത്സവങ്ങളും വ്രതങ്ങളും",
    festivalTitle: "ഈ വർഷത്തെ പ്രധാന ആചരണ ദിനങ്ങൾ",
    festivalBody: "ഇവിടെ നിന്ന് നിർദ്ദിഷ്ട തീയതിയുടെ പഞ്ചാംഗ വിശദാംശങ്ങളിലേക്ക് പോകാം.",
    navToday: "ഇന്ന്",
    navTomorrow: "നാളെ",
    navFestivals: "ഉത്സവങ്ങൾ",
    navCalendar: "കലണ്ടർ",
    openDate: "തീയതി തുറക്കുക",
    dailyLabels: {
      date: "തീയതി",
      country: "രാജ്യം",
      locationTimezone: "സ്ഥലം / സമയം മേഖല",
      openPanchang: "പഞ്ചാംഗം തുറക്കുക",
      sunrise: "സൂര്യോദയം",
      sunset: "സൂര്യാസ്തമയം",
      moonrise: "ചന്ദ്രോദയം",
      moonset: "ചന്ദ്രാസ്തമയം",
      tithi: "തിഥി",
      nakshatra: "നക്ഷത്രം",
      yoga: "യോഗം",
      karana: "കരണം",
      paksha: "പക്ഷം",
      lunarMonth: "ചാന്ദ്രമാസം",
      moonSign: "ചന്ദ്ര രാശി",
      sunSign: "സൂര്യ രാശി",
      samvat: "സംവത്",
      corePanchang: "പ്രധാന പഞ്ചാംഗം",
      segmentTimings: "അവസാന സമയങ്ങൾ",
      tithiEnds: "തിഥി അവസാനിക്കുന്നു",
      nakshatraEnds: "നക്ഷത്രം അവസാനിക്കുന്നു",
      yogaEnds: "യോഗം അവസാനിക്കുന്നു",
      karanaEnds: "കരണം അവസാനിക്കുന്നു",
      dayQuality: "ദിന ഗുണ സമയങ്ങൾ",
      specialTimings: "പ്രത്യേക നക്ഷത്ര സമയങ്ങൾ",
      varjyam: "വർജ്യം",
      amritKalam: "അമൃത കാലം",
      lagnaKundali: "ലഗ്ന കുണ്ടലി",
      ascendant: "ലഗ്നം",
      degree: "ഡിഗ്രി",
      house: "ഭാവം",
      observances: "ആചരണങ്ങളും വ്രതങ്ങളും",
      keepExploring: "കൂടുതൽ കാണുക",
      notAvailable: "ലഭ്യമല്ല",
      unavailable: "വിവരം ലഭ്യമല്ല",
      noMarker: "നിലവിലെ നിയമ അടിസ്ഥാനത്തിലുള്ള സജ്ജീകരണത്തിൽ ഈ ദിവസത്തിന് പ്രധാന ഉത്സവമോ വ്രത സൂചകമോ ഇല്ല.",
      asc: "ലഗ്നം",
    },
    calendarLabels: {
      eyebrow: "ഹിന്ദു കലണ്ടർ",
      loading: "കലണ്ടർ ലോഡ് ചെയ്യുന്നു...",
      openingMonthView: "മാസ ദൃശ്യം തുറക്കുന്നു",
      body: "ഒരു മാസത്തെ തീയതികൾ, തിഥി സൂചനകൾ, പ്രധാന ആചരണ ദിവസങ്ങൾ കാണുക.",
      tamilPanchangam: "തമിഴ് പഞ്ചാംഗം",
      teluguPanchangam: "തെലുങ്ക് പഞ്ചാംഗം",
      noMajorMarker: "പ്രധാന സൂചകം ഇല്ല",
    },
  },
};

export function isSupportedPanchangLanguage(value) {
  return SUPPORTED_PANCHANG_LANGUAGES.some((item) => item.code === value);
}

export function getPanchangLanguage(value) {
  return isSupportedPanchangLanguage(value) ? value : "en";
}

export function getPanchangCopy(language) {
  const resolved = getPanchangLanguage(language);
  return PANCHANG_COPY[resolved] || PANCHANG_COPY.en;
}

export function buildPanchangPath(language, leaf = "") {
  const resolved = getPanchangLanguage(language);
  const normalizedLeaf = leaf.startsWith("/") ? leaf : `/${leaf}`;
  return `/${resolved}/panchang${leaf ? normalizedLeaf : ""}`;
}

export function getPanchangLocale(language) {
  return getPanchangCopy(language).locale || "en-IN";
}
